import { render } from "./DiscoverMore.vue?vue&type=template&id=78f2caff&scoped=true"
import script from "./DiscoverMore.vue?vue&type=script&lang=js"
export * from "./DiscoverMore.vue?vue&type=script&lang=js"

import "./DiscoverMore.scss?vue&type=style&index=0&id=78f2caff&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f2caff"]])

export default __exports__